export type ChatArtifactExportFailure =
  | { kind: 'path_taken' }
  | { kind: 'already_exported' }
  | { kind: 'other'; message: string }

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function asString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() !== '' ? value : undefined
}

export function readChatArtifactExportError(error: unknown): ChatArtifactExportFailure {
  const payload = isRecord(error) ? error : undefined
  const failure = payload && isRecord(payload.error) ? payload.error : payload
  const data = failure && isRecord(failure.data) ? failure.data : undefined
  const status = typeof failure?.status === 'number' ? failure.status : undefined
  const code = asString(data?.code)

  if (status === 409 && code === 'CHAT_ARTIFACT_ALREADY_EXPORTED') {
    return { kind: 'already_exported' }
  }
  if (
    status === 409 &&
    (code === undefined || code === 'DASHBOARD_PATH_TAKEN' || code === 'DOC_PATH_TAKEN')
  ) {
    return { kind: 'path_taken' }
  }

  const message =
    asString(data?.message) ??
    (error instanceof Error ? asString(error.message) : undefined) ??
    'Something went wrong.'
  return { kind: 'other', message }
}
